import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';

const assets = {
  cb: {
    brand: 'assets/images/new-brand-cb.svg',
    brandVert: 'assets/images/login/cb-brand-vert.svg',
    brandMascot: 'assets/images/login/cb-login-section.png',
  },
  pf: {
    brand: 'assets/images/new-brand-pf.svg',
    brandVert: 'assets/images/login/pf-brand-vert.svg',
    brandMascot: 'assets/images/login/pf-login-section.png',
  }
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA;

  @Output()
  onScrollToLoginForm: EventEmitter<void> = new EventEmitter();

  constructor(
    private autenticacaoService: AutenticacaoService,
  ) { }

  ngOnInit(): void {
  }

  get assets() {
    if (this.isCasasBahia) {
      return assets.cb;
    }

    return assets.pf;
  }
  
  handleAcessAccount() {
    this.onScrollToLoginForm.emit()
  }

}
